module.exports = __webpack_public_path__ + "img/icon-banner-dex-cards.e4c4b60f.svg";